import React from "react";
import classes from "./ServicesComponents.module.scss";

const ReceivingMode = ({ onChangeMode, currentMode, errorMsg }) => {
  return (
    <div>
      {currentMode === "TEST" && (
        <>
          <p>
            In order to start accepting invoicing for this company, you need to
            switch receiving to production mode.
          </p>
          <button
            className={`${classes.refreshBtn} px-3`}
            onClick={() => onChangeMode("REI")}
          >
            Switch receiving to production
          </button>
        </>
      )}
      {currentMode === "PROD" && (
        <p>
          The receiving of invoices for this company has been set to
          production mode.
        </p>
      )}
      {currentMode === "error" && <p>{errorMsg}</p>}
    </div>
  );
};

export default ReceivingMode;
